(function() {
  'use strict';

  function maxLimit() {
    var maxLimit = {};

    function link($scope, $element, $attr, $ctrl) {

      if (!$ctrl) return;

      var maxLimit;

      $ctrl.$validators.maxLimit = function(modelValue, viewValue) {
        return $ctrl.$isEmpty(modelValue) || !angular.isDefined(maxLimit) || modelValue <= maxLimit;
      };

      $attr.$observe('maxLimit', function(value) {
        maxLimit = value || undefined;
        $ctrl.$validate();
      });

    }

    maxLimit.restrict = 'A';
    maxLimit.require = 'ngModel';
    maxLimit.link = link;

    return maxLimit;

  }

  angular
    .module('mandaeApp')
    .directive('maxLimit', maxLimit);

}());
